import { axios } from "../../../lib/axios";

export const getDelverFee = async () => {
  const response = await axios.get(`/settings/delivery-fee`);
  // console.log(response.data);

  return response.data;
};
